import { usePageMeta } from "@/hooks/usePageMeta";
import { getMangaBySlug } from "@/mocks/comics";
import { faqList } from "@/mocks/faq";
import Hero from "./components/Hero";
import CategoryNav from "./components/CategoryNav";
import FeaturedSection from "./components/FeaturedSection";
import LatestSection from "./components/LatestSection";
import RankingSection from "./components/RankingSection";
import CompletionBanner from "./components/CompletionBanner";
import FaqSection from "./components/FaqSection";

const SITE_BASE = "https://kisscorner.github.io";

export default function Home() {
  const mainComic = getMangaBySlug("qingmei");

  usePageMeta({
    title: "青梅竹马不断向我甜蜜求婚 漫画大结局免费阅读 - 89890漫画网",
    description:
      "在89890漫画网免费阅读《青梅竹马不断向我甜蜜求婚》漫画大结局，在线畅读完整结局章节，享受免费且高清的恋爱漫画阅读服务。",
    keywords: "青梅竹马不断向我甜蜜求婚,漫画大结局,免费阅读,89890漫画网,恋爱漫画",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": `${SITE_BASE}/#webpage`,
        url: SITE_BASE,
        name: "青梅竹马不断向我甜蜜求婚 漫画大结局免费阅读 - 89890漫画网",
        description:
          "在89890漫画网免费阅读《青梅竹马不断向我甜蜜求婚》漫画大结局，在线畅读完整结局章节。",
        isPartOf: { "@id": `${SITE_BASE}/#website` },
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "ComicSeries",
        name: "青梅竹马不断向我甜蜜求婚",
        url: `${SITE_BASE}/article/qingmei`,
        image: mainComic?.cover,
        author: { "@type": "Person", name: "糖心丸" },
        inLanguage: "zh-CN",
        description: mainComic?.description,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqList.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
          },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <CategoryNav />
      <FeaturedSection />
      <CompletionBanner />
      <LatestSection />
      <RankingSection />
      <FaqSection />
    </>
  );
}